var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-24 py-16"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('delete-account.info-step.heading'))+" ")]),_c('div',{staticClass:"p-info-step"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }